import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RCCheckbox from 'react-simple-checkbox';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .Checkbox {
        width: 1rem;
        height: 1rem;
        svg {
            width: 0.75rem;
            height: 0.75rem;
            transform: scale(1);
        }
    }

    label {
        font-size: 0.7rem;
        text-align: center;
        margin-left: 0.5rem;
    }
`;

export default class Checkbox extends Component {
    static propTypes = {
        checked: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
        primaryColor: PropTypes.string
    }

    static defaultProps = {
        primaryColor: 'black'
    }

    render() {
        const { checked, label, onChange, primaryColor, name, ...rest } = this.props;
        return (
            <CheckboxContainer {...rest}>
                <RCCheckbox
                    checked={checked}
                    onChange={newValue => onChange({ target: { name, type: 'checkbox', checked: newValue } })}
                    id={name}
                    color={primaryColor}
                />
                <label htmlFor="consent">{label}</label>
            </CheckboxContainer>
        )
    }
}
